export default __webpack_public_path__ + "static/media/classroom.4e937ba1.jpg";